import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, Layers } from "lucide-react";
import apiClient from "@/utils/api";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCats = async () => {
      try {
        const { data } = await apiClient.get("/categories");
        setCategories(data || []);
      } catch (e) {
        console.error("Categories fetch error", e);
      } finally {
        setLoading(false);
      }
    };
    fetchCats();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-10">
      
      {/* Header Banner */}
      <div className="bg-[#1C1917] text-white p-8 sm:p-12 rounded-2xl border-2 border-[#D4AF37] relative overflow-hidden shadow-xl">
        <div className="relative z-10 max-w-2xl space-y-3">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#D4AF37]/20 text-[#E6C687] text-xs font-semibold uppercase tracking-wider">
            <Sparkles className="w-3.5 h-3.5 text-[#D4AF37]" />
            Complete Lace Catalog
          </div>
          <h1 
            data-testid="categories-page-title"
            className="font-heading text-3xl sm:text-4xl font-bold text-white"
          >
            Product Categories & Specialized Trims
          </h1>
          <p className="text-stone-300 text-xs sm:text-sm leading-relaxed">
            From zero-size delicate diamond sitara to heavy kora bridal cutwork and galla necklines, explore all 10 specialized lace varieties imported from China.
          </p>
        </div>
      </div>

      {/* Grid of Categories */}
      {loading ? (
        <div className="py-20 text-center text-stone-400 text-sm">
          Loading categories...
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {categories.map((cat, idx) => (
            <div 
              key={cat.id || cat.slug}
              data-testid={`category-detail-card-${cat.slug}`}
              className="bg-white rounded-2xl border border-[#E5E0D8] overflow-hidden shadow-luxury hover:shadow-luxury-hover transition-all duration-300 flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 aspect-[4/3] sm:aspect-auto relative overflow-hidden bg-[#FAF8F5]">
                <img
                  src={cat.image_url}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              <div className="p-6 sm:w-3/5 flex flex-col justify-between space-y-4">
                <div>
                  <div className="flex items-center justify-between text-xs text-[#996515] font-bold uppercase tracking-wider mb-1.5">
                    <span>Category #{idx + 1}</span>
                    {cat.item_count && (
                      <span className="text-stone-400 text-[11px] font-normal">{cat.item_count}+ Designs</span>
                    )}
                  </div>
                  <h3 className="font-heading text-lg sm:text-xl font-bold text-stone-900 leading-snug">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-stone-600 mt-2 leading-relaxed">
                    {cat.description}
                  </p>
                </div>

                <div className="pt-2">
                  <Link
                    to={`/shop?category=${encodeURIComponent(cat.name)}`}
                    data-testid={`btn-explore-category-${cat.slug}`}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-[#1C1917] hover:bg-[#D4AF37] text-white hover:text-[#1C1917] text-xs font-semibold rounded-lg transition"
                  >
                    <span>Browse {cat.name}</span>
                    <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}
